import { formatResultValue } from "../utils/numericUtils";

export default function EuaHedgingResults({ result }) {
    if (!result || Object.keys(result).length === 0) return null;

    return (
        <>
            <div className="fx-results-container">
                <div className="fx-results-left">
                    <table className="fx-results-table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>EU-ETS EUA Spot Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{result.start_date}</td>
                                <td>{formatResultValue(result.start_spot, { isPriceFloat: true })}</td>
                            </tr>
                            <tr>
                                <td>{result.end_date}</td>
                                <td>{formatResultValue(result.end_spot, { isPriceFloat: true })}</td>
                            </tr>
                            <tr className="pl-row">
                                <td>EU-ETS EUA Spot P/L</td>
                                <td>{formatResultValue(result.spot_pl, { isPriceInt: true })}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="fx-results-right">
                    <table className="fx-results-table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>EU-ETS EUA Futures Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{result.start_date}</td>
                                <td>{formatResultValue(result.start_futures, { isPriceFloat: true })}</td>
                            </tr>
                            <tr>
                                <td>{result.end_date}</td>
                                <td>{formatResultValue(result.end_futures, { isPriceFloat: true })}</td>
                            </tr>
                            <tr className="pl-row">
                                <td>EU-ETS EUA Futures P/L</td>
                                <td>{formatResultValue(result.futures_pl, { isPriceInt: true })}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="net-pl-row">
                <span className="net-pl-label">Net EUA Hedging P/L</span>
                <span className="net-pl-value">{formatResultValue(result.net_pl, { isPriceInt: true })}</span>
            </div>

            <div className="divider double"></div>
        </>
    );
}
